module.exports = __webpack_public_path__ + "static/media/Magasins2.14ef90e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Magasins2.svg
// module id = 1752
// module chunks = 0